import {
  ICreateEditHomebannerPayload,
  IUpdateHomebannerSequencePayload,
} from '../../types/api/request/homebannersrequest';
import { IHomebanner } from '../../types/store';
import axiosClient from '../axiosClient';
import { HomebannersEndpoint } from '../endpoints/homebanners';

export const HomebannerService = {
  async getHomebannerGroups(): Promise<string[]> {
    const res = await axiosClient.get<string[]>(HomebannersEndpoint.RETRIEVE_BANNER_GROUPS);
    return res.data;
  },
  async getHomebannersByGroup(bannerGroup: string): Promise<IHomebanner[]> {
    const url = HomebannersEndpoint.RETRIEVE_HOMEBANNERS_BY_GROUP?.replace(
      ':groupName',
      bannerGroup,
    );
    console.log(url);
    const res = await axiosClient.get<IHomebanner[]>(url);

    return res.data;
  },
  async createHomebanner(payload: ICreateEditHomebannerPayload): Promise<IHomebanner> {
    const formData = HomebannerService.buildFormData(payload);
    const res = await axiosClient.post<IHomebanner>(
      HomebannersEndpoint.CREATE_HOMEBANNER,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    );
    return res.data;
  },
  async editHomebanner(payload: ICreateEditHomebannerPayload): Promise<IHomebanner> {
    const formData = HomebannerService.buildFormData(payload);
    const res = await axiosClient.put<IHomebanner>(HomebannersEndpoint.EDIT_HOMEBANNER, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return res.data;
  },
  async deleteHomebanner(id: string) {
    const url = HomebannersEndpoint.DELETE_HOMEBANNER?.replace(':id', id);
    return await axiosClient.delete(url);
  },

  async updateBannerSequence(
    bannerGroup: string,
    payload: IUpdateHomebannerSequencePayload[],
  ): Promise<IHomebanner[]> {
    const url = HomebannersEndpoint.UPDATE_BANNER_SEQUENCE.replace(':groupName', bannerGroup);
    const res = await axiosClient.patch(url, payload);

    return res.data;
  },
  buildFormData(data: ICreateEditHomebannerPayload) {
    const formData = new FormData();

    Object.entries(data).forEach(([key, value]) => {
      if (value === null || value === undefined) return;

      // Handle data_list separately
      if (key === 'data_list' && Array.isArray(value)) {
        value.forEach((item, index) => {
          Object.entries(item).forEach(([itemKey, itemValue]) => {
            if (itemValue !== null && itemValue !== undefined) {
              formData.append(`data_list[${index}].${itemKey}`, String(itemValue));
            }
          });
        });
        return;
      }

      // Handle File vs normal values
      if (value instanceof File) {
        formData.append(key, value);
      } else {
        formData.append(key, String(value));
      }
    });

    return formData;
  },
};
